import {ref} from 'vue'
import {BASE_URL} from "@/composables/url_config";
import {log} from "@/composables/useLog"
import axios from "axios";

const error = ref(null)

export const getDistributorServiceProducts = async (token) => {
    log("welcome in getDistributorServiceProducts")

    if (!token || token === "") {
        return {error: true, message: "No token provided", distributor_service_products: []}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_distributor_service_products_api'
        log("url=" + url)

        const result = await axios.get(url, {headers: headers})
        log("result.data din axios getDistributorServiceProducts")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getDistributorServiceProducts")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getDistributorServiceProducts", distributor_service_products: []}
    }
}

export const addDistributorServiceProduct = async (token, data) => {
    log("welcome in addDistributorServiceProduct")
    log("data:")
    log(data)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/add_distributor_service_product_api'
        log("url=" + url)

        const payload = {
            service_id: data.service_id,
            distributor_id: data.distributor_id,
            product_id: data.product_id,
            mvno_id: data.mvno_id || null,
            active: data.active !== false
        }

        const result = await axios.post(url, payload, {headers: headers})
        log("result.data din axios addDistributorServiceProduct")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in addDistributorServiceProduct")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la addDistributorServiceProduct"}
    }
}

export const updateDistributorServiceProduct = async (token, data) => {
    log("welcome in updateDistributorServiceProduct")
    log("data:")
    log(data)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/update_distributor_service_product_api'
        log("url=" + url)

        const payload = {
            id: data.id,
            service_id: data.service_id,
            distributor_id: data.distributor_id,
            product_id: data.product_id,
            mvno_id: data.mvno_id,
            active: data.active
        }

        const result = await axios.put(url, payload, {headers: headers})
        log("result.data din axios updateDistributorServiceProduct")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in updateDistributorServiceProduct")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la updateDistributorServiceProduct"}
    }
}

export const deleteDistributorServiceProduct = async (token, id) => {
    log("welcome in deleteDistributorServiceProduct")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/delete_distributor_service_product_api'
        log("url=" + url)

        const result = await axios.delete(url, {headers: headers, data: {id: id}})
        log("result.data din axios deleteDistributorServiceProduct")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in deleteDistributorServiceProduct")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la deleteDistributorServiceProduct"}
    }
}

export const getDistributorsForSelect = async (token) => {
    log("welcome in getDistributorsForSelect")

    if (!token || token === "") {
        return {error: true, message: "No token provided", distributors: []}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_distributors_for_select_api'
        log("url=" + url)

        const result = await axios.get(url, {headers: headers})
        log("result.data din axios getDistributorsForSelect")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getDistributorsForSelect")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getDistributorsForSelect", distributors: []}
    }
}

export const getServicesForSelect = async (token) => {
    log("welcome in getServicesForSelect")

    if (!token || token === "") {
        return {error: true, message: "No token provided", services: []}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_services_for_select_api'
        log("url=" + url)

        const result = await axios.get(url, {headers: headers})
        log("result.data din axios getServicesForSelect")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getServicesForSelect")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getServicesForSelect", services: []}
    }
}

export const getServicesForDistributor = async (token, distributorId) => {
    log("welcome in getServicesForDistributor, distributorId=" + distributorId)

    if (!token || token === "") {
        return {error: true, message: "No token provided", services: []}
    }

    if (!distributorId) {
        return {error: false, services: []}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_services_for_distributor_api?distributor_id=' + distributorId
        log("url=" + url)

        const result = await axios.get(url, {headers: headers})
        log("result.data din axios getServicesForDistributor")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getServicesForDistributor")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getServicesForDistributor", services: []}
    }
}

export const getProductsForDistributor = async (token, distributorId) => {
    log("welcome in getProductsForDistributor, distributorId=" + distributorId)

    if (!token || token === "") {
        return {error: true, message: "No token provided", products: []}
    }

    if (!distributorId) {
        return {error: false, products: []}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_products_for_distributor_api?distributor_id=' + distributorId
        log("url=" + url)

        const result = await axios.get(url, {headers: headers})
        log("result.data din axios getProductsForDistributor")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getProductsForDistributor")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getProductsForDistributor", products: []}
    }
}

export const getMvnosForSelect = async (token) => {
    log("welcome in getMvnosForSelect")

    if (!token || token === "") {
        return {error: true, message: "No token provided", mvnos: []}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_mvnos_for_select_api'
        log("url=" + url)

        const result = await axios.get(url, {headers: headers})
        log("result.data din axios getMvnosForSelect")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getMvnosForSelect")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getMvnosForSelect", mvnos: []}
    }
}

const useDistributorServiceProductsAPI = () => {
    return {
        error,
        getDistributorServiceProducts,
        addDistributorServiceProduct,
        updateDistributorServiceProduct,
        deleteDistributorServiceProduct,
        getDistributorsForSelect,
        getServicesForSelect,
        getServicesForDistributor,
        getProductsForDistributor,
        getMvnosForSelect
    }
}

export default useDistributorServiceProductsAPI
